// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2fxf3","inner":"Form_inner__otpim","range":"Form_range__2rZpu","name":"Form_name__3IJNW","actions":"Form_actions__LpnvX"};